import { $t } from '@/i18n'
import { METIERSIMMMO, PROMOTEUR, METIERSVO } from '@/helpers/constantes/metiersConstants'
export default {
  namespace: true,
  state: {
    tutoralsVideos: [
      {
        id: 1,
        title: $t('tutoralsVideos.videos.title1'),
        category: $t('tutoralsVideos.menu.linkDashboard'),
        sectionId: 1,
        dateOfPublicationOnline: '26/02/2024',
        newReleaseEndDate: new Date('march 11, 2024 20:00:00'),
        linkVideo: 'https://www.youtube.com/embed/MlQ5guviHBk?si=-ihYTbIV5jsEQaeP',
        description: $t('tutoralsVideos.videos.description1'),
        metiers: [...METIERSIMMMO, ...PROMOTEUR, ...METIERSVO]

      },
      {
        id: 2,
        title: $t('tutoralsVideos.videos.title2'),
        category: $t('tutoralsVideos.menu.linkAnnouncementsPage'),
        sectionId: 2,
        dateOfPublicationOnline: '26/02/2024',
        newReleaseEndDate: new Date('march 11, 2024 20:00:00'),
        linkVideo: 'https://www.youtube.com/embed/EDbat5rw4ao?si=Nk0i6YKj7Tz2XM6P',
        description: $t('tutoralsVideos.videos.description2'),
        metiers: [METIERSIMMMO]
      },
      {
        id: 3,
        title: $t('tutoralsVideos.videos.title3'),
        category: $t('tutoralsVideos.menu.linkBroadcast'),
        sectionId: 3,
        dateOfPublicationOnline: '26/02/2024',
        newReleaseEndDate: new Date('march 11, 2024 20:00:00'),
        linkVideo: 'https://www.youtube.com/embed/3Qwr6DtxneY?si=bMU8RiMoNseEu1ZP',
        description: $t('tutoralsVideos.videos.description3'),
        metiers: [...METIERSIMMMO, ...PROMOTEUR, ...METIERSVO]
      },
      {
        id: 4,
        title: $t('tutoralsVideos.videos.title4'),
        category: $t('tutoralsVideos.menu.linkContactManager'),
        sectionId: 4,
        dateOfPublicationOnline: '26/02/2024',
        newReleaseEndDate: new Date('march 11, 2024 20:00:00'),
        linkVideo: 'https://www.youtube.com/embed/2yp3EPjV77s?si=2rhDeLExOThzfNgp',
        description: $t('tutoralsVideos.videos.description4'),
        metiers: [...METIERSIMMMO, ...PROMOTEUR, ...METIERSVO]
      },
      {
        id: 5,
        title: $t('tutoralsVideos.videos.title5'),
        category: $t('tutoralsVideos.menu.linkAnnouncementsPage'),
        sectionId: 2,
        dateOfPublicationOnline: '26/02/2024',
        newReleaseEndDate: new Date('march 11, 2024 20:00:00'),
        linkVideo: 'https://www.youtube.com/embed/pyKyGVuN0W4?si=f-MKvkV3DK9M2R5N',
        description: $t('tutoralsVideos.videos.description5'),
        metiers: [...METIERSIMMMO]
      },
      {
        id: 6,
        title: $t('tutoralsVideos.videos.title6'),
        category: $t('tutoralsVideos.menu.linkSocialManagement'),
        sectionId: 5,
        dateOfPublicationOnline: '15/04/2024',
        newReleaseEndDate: new Date('may 06, 2024 20:00:00'),
        linkVideo: 'https://www.youtube.com/embed/SB3xcNnRec0?si=gT74BAKjBxOcnyDa',
        description: $t('tutoralsVideos.videos.description6'),
        metiers: [...METIERSIMMMO, ...PROMOTEUR, ...METIERSVO]
      }
    ]
  },
  getters: {
    getTutoralsVideos: (state) => state.tutoralsVideos
  },
  mutations: {},
  actions: {}
}
